// Ensures on each new render, the page starts at the top (https://www.youtube.com/watch?v=YGHHmbWIaqs)
function AlwaysTop() {
  return window.scroll(0, 0);
}

export default AlwaysTop